(() => {
  const slugify = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  const buildToc = (root) => {
    const content = root.querySelector('[data-yc-article-content]');
    const toc = root.querySelector('[data-yc-article-toc]');
    const list = root.querySelector('[data-yc-article-toc-list]');
    if (!content || !toc || !list) return;

    // H2 only: compact, stable and useful on mobile. H3 remains semantic content.
    const headings = [...content.querySelectorAll('h2')]
      .filter((heading) => heading.textContent.trim().length > 0);

    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }

    const usedIds = new Set([...document.querySelectorAll('[id]')].map((node) => node.id));
    const fragment = document.createDocumentFragment();

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = slugify(heading.textContent) || `section-${index + 1}`;
        let candidate = base;
        let suffix = 2;
        while (usedIds.has(candidate)) {
          candidate = `${base}-${suffix}`;
          suffix += 1;
        }
        heading.id = candidate;
        usedIds.add(candidate);
      }

      const item = document.createElement('li');
      item.className = 'yc-article-toc__item yc-article-toc__item--h2';
      const link = document.createElement('a');
      link.className = 'yc-article-toc__link';
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      fragment.appendChild(item);
    });

    list.replaceChildren(fragment);
    toc.hidden = false;
  };

  const enhanceTables = (root) => {
    const content = root.querySelector('[data-yc-article-content]');
    if (!content) return;

    content.querySelectorAll('table:not([data-yc-table-ready])').forEach((table) => {
      table.dataset.ycTableReady = 'true';

      let wrapper = table.closest('.yc-article-table-scroll');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'yc-article-table-scroll';
        table.before(wrapper);
        wrapper.appendChild(table);
      }

      const hasComplexSpans = table.querySelector('[rowspan]:not([rowspan="1"]), [colspan]:not([colspan="1"])');
      const headerCells = [...table.querySelectorAll('thead tr:last-child th')];
      const bodyRows = [...table.querySelectorAll('tbody tr')];

      if (hasComplexSpans || headerCells.length === 0 || bodyRows.length === 0) return;
      if (!bodyRows.every((row) => row.cells.length === headerCells.length)) return;

      headerCells.forEach((header) => {
        if (!header.hasAttribute('scope')) header.setAttribute('scope', 'col');
      });

      bodyRows.forEach((row) => {
        [...row.cells].forEach((cell, index) => {
          const label = headerCells[index]?.textContent.trim();
          if (label && !cell.dataset.label) cell.dataset.label = label;
          if (index === 0 && !cell.hasAttribute('role')) cell.setAttribute('role', 'rowheader');
        });
      });

      wrapper.classList.add('yc-article-table-scroll--cards');
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-yc-article]:not([data-yc-article-ready])').forEach((root) => {
      root.dataset.ycArticleReady = 'true';
      buildToc(root);
      enhanceTables(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
